var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Icon } from '../../display/Icon';
import { Spinner } from '../../display/Spinner';
import { TextInput } from '../../forms/TextInput';
import { camelCaseAriaAttrs } from '../../../utils/formatAriaAttrKeys';
import { Animation, Colors } from '../../../theme';
const Styles = labelStyles('TypeaheadInput', {
    clearSelectionButton: css `
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;

    &:hover,
    &:focus {
      color: ${Colors.neutral600};
      transition: ${Animation.transitionValue};
    }
  `,
});
const ClearSelectionButton = ({ clearSelection, }) => {
    return (isolateComponent("button", { type: "button", css: Styles.clearSelectionButton, onClick: clearSelection, title: "Clear Selection" },
        isolateComponent(Icon, { canAcceptPointerEvents: false, name: "x", size: 20 })));
};
const InputIcon = (props) => {
    return props.renderIcon && props.selectedItem ? (props.renderIcon(props.selectedItem, props.getLabelForItem)) : (isolateComponent(Icon, { name: "magnifyingGlass", size: props.iconSize }));
};
export const TypeaheadInput = (_a) => {
    var { size = 'small' } = _a, props = __rest(_a, ["size"]);
    const showClearSelectionButton = props.selectedItem && !props.isDisabled;
    return (isolateComponent(TextInput, Object.assign({}, camelCaseAriaAttrs(props.getInputProps({
        ariaLabelledBy: props.ariaLabelledBy,
        autoComplete: props.autoComplete,
        onFocus: props.onFocus,
        onKeyDown: props.onKeyDown,
    })), { ariaLabel: props.ariaLabel, autoComplete: "off", canClickIconAfter: showClearSelectionButton, disabledText: props.disabledText, isDisabled: props.isDisabled, isErrored: props.isErrored, placeholder: props.placeholder, onBlur: props.onBlur, renderIconAfter: ({ iconSize, isFocused, isHovered }) => showClearSelectionButton ? (isolateComponent(ClearSelectionButton, { clearSelection: props.clearSelection, isFocused: isFocused, isHovered: isHovered })) : (props.iconEndName && isolateComponent(Icon, { name: props.iconEndName, size: iconSize })), renderIconBefore: ({ iconSize }) => {
            if (props.isBusy) {
                return (isolateComponent("span", { style: { width: iconSize } },
                    isolateComponent(Spinner, null)));
            }
            return isolateComponent(InputIcon, Object.assign({}, props, { iconSize: iconSize }));
        }, size: size })));
};
//# sourceMappingURL=TypeaheadInput.js.map
// @zapier/design-system@6.27.0 (617a97f69)
